const _ = require("lodash");
const AT = require("../ActionTypes");

// Pass a vault to this function to make it so that if the denylisted types
// below are dispatched on one page and handled on another page, they are
// suppressed entirely. Partially fixes T11005, where two actions happen at the
// same time and the first one does things that make handling the second action
// nonsense.

// These are the only action types affected by this fix.
// TODO: really hard to know what to put here... mostly just added things you
// can do on a problem page.
const denylistedTypes = {
	[AT.CONFIRM_PAGE_NAVIGATION]: true,

	[AT.PLAY_BLOCK_REQUEST]: true,
	[AT.PLAY_LAB_BLOCK_REQUEST]: true,
	[AT.BLOCK_HISTORY_REQUEST]: true,
	[AT.SUBMIT_TRIAL]: true,
	[AT.SUBMIT_TEST]: true,
	[AT.QUIT_TEST_BLOCK_REQUEST]: true,
	[AT.SAVE_TEST_ANSWER]: true,
	[AT.SAVE_TRIAL_STATE]: true,
	[AT.CHANGE_TRIAL_STATE]: true,
	[AT.REPLAY_BLOCK]: true,
	[AT.REPLAY_PROBLEM]: true,
	[AT.NEXT_PROBLEM]: true,
	[AT.GOTO_FINAL]: true,
	[AT.PREVIOUS_PROBLEM]: true,
	[AT.REVIEW_QUIT_CHOICE]: true,
	[AT.SET_SHOW_INSTRUCTIONS]: true,
	[AT.REQUEST_SPECIFIC_SET]: true,
	[AT.UPDATE_VIDEO_POSITION]: true,
};

const addMisorderedDispatchFix = function(vault, vaultLogger) {
	vault.addDispatchMiddleware((action, state) => {
		if (denylistedTypes[action.type]) {
			// Lodash grabs symbols in _.clone but not _.extend, so we use clone
			// here. (The vault logger uses symbols for tracking dispatch times.)
			action = _.clone(action);
			action.dispatchPage = state.page;
		}
		return action;
	});

	vault.addPreHandleMiddleware((action, state) => {
		// Note: We could do _.isEqual for pages instead, although it's slower.
		// It's technically more correct, but we're assuming action handlers don't
		// carelessly set a new page object without any changes.
		if (denylistedTypes[action.type] && action.dispatchPage !== state.page) {
			vaultLogger.logSuppressedAction(action, "Page changed before handling");
			return null;
		}
		return action;
	});
};

module.exports = {
	addMisorderedDispatchFix,
};
